import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API from "api";

export const fetchNotifications = createAsyncThunk(
    "notifications/fetchNotifications",
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await API.get("/notifications");
            return data || [];
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch notifications");
        }
    }
);

const notificationSlice = createSlice({
    name: "notifications",
    initialState: [],
    reducers: {
        addNotification: (state, action) => {
            state.push(action.payload);
        },
        removeNotification: (state, action) => {
            return state.filter((notif) => (notif.id || notif._id) !== action.payload);
        },
        setNotifications: (_state, action) => {
            return action.payload || [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchNotifications.fulfilled, (_state, action) => {
            return action.payload || [];
        });
    }
})

export const {addNotification, removeNotification, setNotifications} = notificationSlice.actions;

export default notificationSlice.reducer;
